import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '../stores/authStore'
import { getCurrentUser } from '../lib/auth'

export const Route = createFileRoute('/')({
  beforeLoad: async ({ location }) => {
    const state = useAuthStore.getState()

    // If the auth check hasn't completed yet, perform it directly here
    // to avoid a deadlock (useAuth's useEffect only fires after component mount,
    // but beforeLoad blocks component mounting).
    if (state.isLoading) {
      try {
        const user = await getCurrentUser()
        useAuthStore.getState().setUser({
          id: user.id,
          email: user.email,
          name: user.name,
          role: user.role,
        })
      } catch {
        useAuthStore.getState().setUser(null)
      }
    }

    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.pathname !== '/' ? location.pathname : undefined,
        },
      })
    }

    // Authenticated users always redirect to /dashboard
    throw redirect({ to: '/dashboard' })
  },
  component: () => null,
})
